import _ from 'lodash';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';

const configuration = {
  type: 'averageDirectionalIndex',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes'
    },
    type: 'averageDirectionalIndex',
    name: 'adx',
    config: {
      DILength: 14,
      ADXSmoothing: 14,
      candleInterval: '5 minutes',
      valuePaths: [
        'item0.equity'
      ]
    }
  },
  searchTerms: [
    'ADX (Average Directional Index)',
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.equity, SEGMENT_CONFIG.future]
  },
  buildOutputSchema: (pipe) => {
    const { name, type } = pipe;

    const properties = [
      { label: 'adx+dmi', value: 'pdi' },
      { label: 'adx-dmi', value: 'mdi' },
      { label: 'adx', value: 'adx' },
    ];

    return _.map(properties, (property) => {
      const { label, value } = property;

      return {
        name: `${name}.${value}`,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: name === 'adx' ? label : `${name} ${label}`,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      };
    });
  },
  isEnabled: true,
  priority: 10
};
export default configuration;
